export default {
  videos : [],
  video: {}
}